// Export an array of topics for VA 1st Grade Math
const nc1stMathQuizContent = [
  // === NC 1st Grade Math — additions ===

  {
    "slug": "addingfun",
    "title": "Adding Fun",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is 5 + 3?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "7", "correct": false },
          { "text": "6", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "You have 2 apples and get 3 more. How many apples now?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "4", "correct": false },
          { "text": "6", "correct": false },
          { "text": "3", "correct": false }
        ]
      },
      {
        "question": "What is 6 + 4?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "9", "correct": false },
          { "text": "8", "correct": false },
          { "text": "11", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "takingaway",
    "title": "Taking Away",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is 9 − 2?",
        "answers": [
          { "text": "7", "correct": true },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "You had 8 cookies and ate 3. How many left?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "6", "correct": false },
          { "text": "4", "correct": false },
          { "text": "3", "correct": false }
        ]
      },
      {
        "question": "What is 10 − 6?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "5", "correct": false },
          { "text": "3", "correct": false },
          { "text": "6", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "addingproperties",
    "title": "Adding Properties",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which equation shows turning addends around doesn’t change the sum?",
        "answers": [
          { "text": "4 + 5 = 5 + 4", "correct": true },
          { "text": "4 + 5 = 4 + 6", "correct": false },
          { "text": "4 + 5 = 9 + 1", "correct": false },
          { "text": "4 + 5 = 3 + 5", "correct": false }
        ]
      },
      {
        "question": "What is 1 + 0?",
        "answers": [
          { "text": "1", "correct": true },
          { "text": "0", "correct": false },
          { "text": "2", "correct": false },
          { "text": "10", "correct": false }
        ]
      },
      {
        "question": "Fill in the blank: 2 + 3 = 3 + __",
        "answers": [
          { "text": "2", "correct": true },
          { "text": "1", "correct": false },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "understandtheequalsign",
    "title": "Understand the equal sign",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which equation is true?",
        "answers": [
          { "text": "3 + 2 = 5", "correct": true },
          { "text": "4 = 2 + 3 + 1", "correct": false },
          { "text": "6 = 7", "correct": false },
          { "text": "5 + 1 = 5", "correct": false }
        ]
      },
      {
        "question": "Which side has the same value: 4 + 1 __ 3 + 2",
        "answers": [
          { "text": "=", "correct": true },
          { "text": ">", "correct": false },
          { "text": "<", "correct": false },
          { "text": "≠", "correct": false }
        ]
      },
      {
        "question": "Choose the true statement.",
        "answers": [
          { "text": "2 + 4 = 6", "correct": true },
          { "text": "2 + 4 = 5", "correct": false },
          { "text": "6 = 7", "correct": false },
          { "text": "0 = 1", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countto50",
    "title": "Count to 50",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 19?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "18", "correct": false },
          { "text": "21", "correct": false },
          { "text": "29", "correct": false }
        ]
      },
      {
        "question": "What number comes after 29?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "28", "correct": false },
          { "text": "31", "correct": false },
          { "text": "39", "correct": false }
        ]
      },
      {
        "question": "What number comes before 40?",
        "answers": [
          { "text": "39", "correct": true },
          { "text": "41", "correct": false },
          { "text": "38", "correct": false },
          { "text": "30", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countfrom50to100",
    "title": "Count from 50 to 100",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 50?",
        "answers": [
          { "text": "51", "correct": true },
          { "text": "60", "correct": false },
          { "text": "49", "correct": false },
          { "text": "59", "correct": false }
        ]
      },
      {
        "question": "What comes after 59?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "58", "correct": false },
          { "text": "61", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "What number comes before 70?",
        "answers": [
          { "text": "69", "correct": true },
          { "text": "71", "correct": false },
          { "text": "68", "correct": false },
          { "text": "60", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countfrom100to150",
    "title": "Count from 100 to 150",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What comes after 109?",
        "answers": [
          { "text": "110", "correct": true },
          { "text": "111", "correct": false },
          { "text": "100", "correct": false },
          { "text": "120", "correct": false }
        ]
      },
      {
        "question": "Which number is between 119 and 121?",
        "answers": [
          { "text": "120", "correct": true },
          { "text": "122", "correct": false },
          { "text": "118", "correct": false },
          { "text": "130", "correct": false }
        ]
      },
      {
        "question": "What number comes before 130?",
        "answers": [
          { "text": "129", "correct": true },
          { "text": "131", "correct": false },
          { "text": "120", "correct": false },
          { "text": "128", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countby10s",
    "title": "Count By 10's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What comes next: 10, 20, 30, __?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "31", "correct": false },
          { "text": "35", "correct": false },
          { "text": "50", "correct": false }
        ]
      },
      {
        "question": "Which list counts by 10s?",
        "answers": [
          { "text": "40, 50, 60, 70", "correct": true },
          { "text": "41, 42, 43, 44", "correct": false },
          { "text": "14, 24, 34, 44", "correct": false },
          { "text": "4, 5, 6, 7", "correct": false }
        ]
      },
      {
        "question": "What comes after 80 when counting by 10s?",
        "answers": [
          { "text": "90", "correct": true },
          { "text": "81", "correct": false },
          { "text": "88", "correct": false },
          { "text": "100", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "greaterthan",
    "title": "Greater Than",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which symbol makes this true: 47 __ 52",
        "answers": [
          { "text": "<", "correct": true },
          { "text": ">", "correct": false },
          { "text": "=", "correct": false },
          { "text": "≠", "correct": false }
        ]
      },
      {
        "question": "Which number is greatest?",
        "answers": [
          { "text": "63", "correct": true },
          { "text": "36", "correct": false },
          { "text": "48", "correct": false },
          { "text": "52", "correct": false }
        ]
      },
      {
        "question": "70 __ 70",
        "answers": [
          { "text": "=", "correct": true },
          { "text": "<", "correct": false },
          { "text": ">", "correct": false },
          { "text": "≠", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "shortlonglinethemup",
    "title": "Short, Long, Line Them Up",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "A red straw is 5 paperclips long. A blue straw is 3 paperclips long. Which is longer?",
        "answers": [
          { "text": "Red straw", "correct": true },
          { "text": "Blue straw", "correct": false },
          { "text": "They’re the same", "correct": false },
          { "text": "Not enough info", "correct": false }
        ]
      },
      {
        "question": "Put these by length (short to long): 2, 4, 3 units.",
        "answers": [
          { "text": "2, 3, 4", "correct": true },
          { "text": "4, 3, 2", "correct": false },
          { "text": "3, 2, 4", "correct": false },
          { "text": "2, 4, 3", "correct": false }
        ]
      },
      {
        "question": "Two lines start at the same point. The one that reaches farther is ____.",
        "answers": [
          { "text": "longer", "correct": true },
          { "text": "shorter", "correct": false },
          { "text": "the same", "correct": false },
          { "text": "curved", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "nonstandard",
    "title": "Non-Standard",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "When measuring with paperclips, they should be placed ____.",
        "answers": [
          { "text": "end to end with no gaps", "correct": true },
          { "text": "in a pile", "correct": false },
          { "text": "far apart", "correct": false },
          { "text": "standing up", "correct": false }
        ]
      },
      {
        "question": "A book is 8 cubes long. A pencil is 5 cubes long. Which is longer?",
        "answers": [
          { "text": "The book", "correct": true },
          { "text": "The pencil", "correct": false },
          { "text": "Same length", "correct": false },
          { "text": "Not sure", "correct": false }
        ]
      },
      {
        "question": "Which is a non-standard unit?",
        "answers": [
          { "text": "Paperclips", "correct": true },
          { "text": "Inches", "correct": false },
          { "text": "Centimeters", "correct": false },
          { "text": "Meters", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "tellingtime",
    "title": "Telling time",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Hour hand on 3 and minute hand on 12 shows:",
        "answers": [
          { "text": "3:00", "correct": true },
          { "text": "3:30", "correct": false },
          { "text": "12:03", "correct": false },
          { "text": "12:30", "correct": false }
        ]
      },
      {
        "question": "Half past 6 is:",
        "answers": [
          { "text": "6:30", "correct": true },
          { "text": "6:00", "correct": false },
          { "text": "7:30", "correct": false },
          { "text": "6:15", "correct": false }
        ]
      },
      {
        "question": "When the minute hand is on 6, it is ____ the hour.",
        "answers": [
          { "text": "half past", "correct": true },
          { "text": "on the hour", "correct": false },
          { "text": "quarter past", "correct": false },
          { "text": "quarter to", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "dollarscents",
    "title": "Dollars & Cents",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "A nickel is worth how many cents?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "1", "correct": false },
          { "text": "10", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Which makes 10 cents?",
        "answers": [
          { "text": "1 dime", "correct": true },
          { "text": "2 nickels", "correct": false },
          { "text": "10 pennies and 1 penny", "correct": false },
          { "text": "1 quarter", "correct": false }
        ]
      },
      {
        "question": "Which equals 25 cents?",
        "answers": [
          { "text": "1 quarter", "correct": true },
          { "text": "2 dimes", "correct": false },
          { "text": "2 nickels", "correct": false },
          { "text": "1 nickel and 1 penny", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "bargraph",
    "title": "Bar Graph",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What does a bar graph show?",
        "answers": [
          { "text": "Data with bars you can compare", "correct": true },
          { "text": "Only pictures of animals", "correct": false },
          { "text": "Maps of roads", "correct": false },
          { "text": "Stories", "correct": false }
        ]
      },
      {
        "question": "If 7 kids like cats and 4 like dogs, how many more like cats?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "2", "correct": false },
          { "text": "11", "correct": false },
          { "text": "1", "correct": false }
        ]
      },
      {
        "question": "If 3 kids like red, 2 like blue, and 1 likes green, how many in all?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "3", "correct": false },
          { "text": "1", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "pictograph",
    "title": "Pictograph",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "In a pictograph, the key tells you:",
        "answers": [
          { "text": "How much each picture is worth", "correct": true },
          { "text": "How to draw a picture", "correct": false },
          { "text": "Where to sit", "correct": false },
          { "text": "What time it is", "correct": false }
        ]
      },
      {
        "question": "If each picture = 2 votes and there are 3 pictures, how many votes?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "3", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "Pizza has 5 pictures and tacos have 3. Which got more votes?",
        "answers": [
          { "text": "Pizza", "correct": true },
          { "text": "Tacos", "correct": false },
          { "text": "Same", "correct": false },
          { "text": "Not sure", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "shapes",
    "title": "Shapes",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which shape has 3 sides?",
        "answers": [
          { "text": "Triangle", "correct": true },
          { "text": "Square", "correct": false },
          { "text": "Circle", "correct": false },
          { "text": "Rectangle", "correct": false }
        ]
      },
      {
        "question": "Which shape has 4 equal sides?",
        "answers": [
          { "text": "Square", "correct": true },
          { "text": "Triangle", "correct": false },
          { "text": "Pentagon", "correct": false },
          { "text": "Oval", "correct": false }
        ]
      },
      {
        "question": "Which 3D shape rolls easily?",
        "answers": [
          { "text": "Sphere", "correct": true },
          { "text": "Cube", "correct": false },
          { "text": "Rectangular prism", "correct": false },
          { "text": "Pyramid", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "builditflat",
    "title": "Build It Flat",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Two equal right triangles can fit together to make a ____.",
        "answers": [
          { "text": "Rectangle", "correct": true },
          { "text": "Circle", "correct": false },
          { "text": "Cone", "correct": false },
          { "text": "Sphere", "correct": false }
        ]
      },
      {
        "question": "Which set can make a square?",
        "answers": [
          { "text": "Two equal triangles", "correct": true },
          { "text": "Two circles", "correct": false },
          { "text": "One triangle and one circle", "correct": false },
          { "text": "Only one rectangle", "correct": false }
        ]
      },
      {
        "question": "Putting shapes together to make new shapes is called:",
        "answers": [
          { "text": "Composing shapes", "correct": true },
          { "text": "Coloring shapes", "correct": false },
          { "text": "Counting shapes", "correct": false },
          { "text": "Erasing shapes", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "cutitequal",
    "title": "Cut It Equal",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Cut a rectangle into 2 equal parts. Each part is called a ____.",
        "answers": [
          { "text": "half", "correct": true },
          { "text": "third", "correct": false },
          { "text": "fourth", "correct": false },
          { "text": "whole", "correct": false }
        ]
      },
      {
        "question": "Cut a circle into 4 equal parts. Each part is a ____.",
        "answers": [
          { "text": "fourth (quarter)", "correct": true },
          { "text": "half", "correct": false },
          { "text": "third", "correct": false },
          { "text": "eighth", "correct": false }
        ]
      },
      {
        "question": "Equal parts are also called:",
        "answers": [
          { "text": "fair shares", "correct": true },
          { "text": "random pieces", "correct": false },
          { "text": "tiny bits", "correct": false },
          { "text": "leftovers", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "halfoffourthof",
    "title": "Half of, Fourth of",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Half of 8 is:",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "2", "correct": false },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "A fourth of 8 is:",
        "answers": [
          { "text": "2", "correct": true },
          { "text": "3", "correct": false },
          { "text": "4", "correct": false },
          { "text": "6", "correct": false }
        ]
      },
      {
        "question": "Which shows a half?",
        "answers": [
          { "text": "2 equal parts", "correct": true },
          { "text": "3 equal parts", "correct": false },
          { "text": "4 equal parts", "correct": false },
          { "text": "5 equal parts", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "wholeagain",
    "title": "Whole Again",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Two halves make a ____.",
        "answers": [
          { "text": "whole", "correct": true },
          { "text": "third", "correct": false },
          { "text": "fourth", "correct": false },
          { "text": "piece", "correct": false }
        ]
      },
      {
        "question": "Four fourths make a ____.",
        "answers": [
          { "text": "whole", "correct": true },
          { "text": "half", "correct": false },
          { "text": "third", "correct": false },
          { "text": "quarter", "correct": false }
        ]
      },
      {
        "question": "1/4 + 3/4 equals:",
        "answers": [
          { "text": "1 whole", "correct": true },
          { "text": "1/2", "correct": false },
          { "text": "2/4", "correct": false },
          { "text": "0", "correct": false }
        ]
      }
    ]
  }
];




export default nc1stMathQuizContent;
